import { render, staticRenderFns } from "./ButtonEl.vue?vue&type=template&id=51505ff6&scoped=true&"
import script from "./ButtonEl.vue?vue&type=script&lang=js&"
export * from "./ButtonEl.vue?vue&type=script&lang=js&"
import style0 from "./ButtonEl.vue?vue&type=style&index=0&id=51505ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51505ff6",
  null
  
)

export default component.exports